import { editorPicks } from "@/mocks/comics";
import SectionHeader from "./SectionHeader";
import ComicCard from "./ComicCard";

export default function EditorPicks() {
  const [spotlight, ...rest] = editorPicks;
  return (
    <section id="编辑推荐" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <SectionHeader
        eyebrow="编辑推荐"
        eyebrowTone="primary"
        title={
          <>
            编辑推荐书单 <span className="text-primary-600">· 本月最值得读</span>
          </>
        }
        subtitle="由编辑部逐字精读后选出的四部诚意之作，从东方奇幻到都市治愈，总有一部能让你一口气读到天亮。"
      />

      {/* spotlight */}
      <article className="mb-6 grid overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:grid-cols-2">
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-background-200 lg:aspect-auto lg:h-full">
          <img
            src={spotlight.cover}
            alt={`${spotlight.title} 编辑推荐主力漫画封面`}
            className="h-full w-full object-cover object-top"
          />
          <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
            本期主打
          </span>
        </div>
        <div className="flex flex-col justify-center gap-4 p-6 md:p-10">
          <span className="text-xs font-medium tracking-widest text-primary-600">
            {spotlight.genre} · 编辑评分 {spotlight.rating}
          </span>
          <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            《{spotlight.title}》
          </h3>
          <p className="text-sm text-foreground-600">{spotlight.summary}</p>
          <blockquote className="border-l-2 border-secondary-400 pl-4 text-sm leading-relaxed text-foreground-700">
            {spotlight.note}
          </blockquote>
          <div className="flex flex-wrap gap-2">
            {spotlight.tags.map((tag) => (
              <span key={tag} className="rounded-md bg-background-200 px-2.5 py-1 text-xs text-foreground-700">
                {tag}
              </span>
            ))}
          </div>
          <div className="mt-2">
            <a
              href="#每日精选"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看完整书单 <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </article>

      {/* rest */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {rest.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}